<template>
   <v-app>
        <v-container align="center">
            <v-row>
                <v-col cols="12">
                    <v-card align="center" flat>
                        
                            <v-col cols="12" md="8">
                                <h1> Turno Confirmado 
                                </h1>
                            </v-col>
                            <v-col cols="12" md="8">
                                <h3> El dia {{fechaString}} usted tiene un turno agendado con: {{profesionalName}}
                                </h3>
                                <h3> En la especiliadad de: {{profesionalEspecialidad}}
                                </h3>
                            </v-col>
                            <v-col cols="12" md="8">
                                <h3> La direccion del consultorio es {{direccion}}
                                </h3>
                            </v-col>    
        
                    </v-card>
                </v-col>   
            </v-row> 
        </v-container>
   </v-app>
</template>

<script>

//import axios from 'axios';
//import AxiosError from 'axios'

    export default {
        name: 'turno',
        data() {
            return {
                profesionalName: '',
                profesionalEspecialidad:'',
                start:this.$store.state.turno.start,
                end:this.$store.state.turno.end,
                direccion:'',
                /*authinfo: {
                    thalamus_server: this.$default_thalamus_server,
                    federation_acct: "",
                },*/
                dia: '',
                fecha: '',
                mes: '',
                hora: '',
                minutos: '',
                fechaString: '',
                stderr: []
            }
        },
        created(){
            
            this.getFechaTurno(this.$store.state.turno.start)
            this.profesionalName = this.$store.state.turno.profesional_name

            this.profesionalEspecialidad = this.$store.state.turno.especialidad

            this.direccion = this.$store.state.turno.direccion

        },
        methods: {
            
                            
        
            getFechaTurno(f){
                let day;
                if (f.getDay()===1){
                    day="Lunes"
                }
                else if (f.getDay()===2){
                    day="Martes"
                }
                if (f.getDay()===3){
                    day="Miercoles"
                }
                if (f.getDay()===4){
                    day="Jueves"
                }
                if (f.getDay()===5){
                    day="Viernes"
                }
                if (f.getDay()===6){
                    day="Sabado"
                }
                let month
                if (f.getMonth()===0){
                    month="Enero"
                }
                else if (f.getMonth()===1){
                    month="Febrero"
                }
                else if (f.getMonth()===2){
                    month="Marzo"
                }
                else if (f.getMonth()===3){
                    month="Abril"
                }
                else if (f.getMonth()===4){
                    month="Mayo"
                }
                else if (f.getMonth()===5){
                    month="Junio"
                }
                else if (f.getMonth()===6){
                    month="Julio"
                }
                else if (f.getMonth()===7){
                    month="Agosto"
                }
                else if (f.getMonth()===8){
                    month="Septiembre"
                }
                else if (f.getMonth()===9){
                    month="Octubre"
                }
                else if (f.getMonth()===10){
                    month="Noviembre"
                }
                else if (f.getMonth()===11){
                    month="Diciembre"
                }
                this.dia=day
                this.fecha=f.getDate()
                this.mes=month
                this.hora=f.getHours()
                this.minutos=f.getMinutes().toString()
                if (this.minutos.length==1){
                    this.minutos="0"+this.minutos
                }
                this.fechaString = this.dia + " " + this.fecha + " de " + this.mes + " a las " + this.hora + ":" + this.minutos + "hs"
            }
        }
    }
</script>